/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseContact } from '../../models/api-response-contact';

export interface GetContactByReference$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  reference: string;
}

export function getContactByReference(http: HttpClient, rootUrl: string, params: GetContactByReference$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseContact>> {
  const rb = new RequestBuilder(rootUrl, getContactByReference.PATH, 'get');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.path('reference', params.reference, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseContact>;
    })
  );
}

getContactByReference.PATH = '/v1/api/ui/contacts/{reference}';
